module.exports = __webpack_public_path__ + "img/UpperIntermediateGroups.1d0467a2.webp";